module.exports = __webpack_public_path__ + "img/banner.6d583b3d.png";